import { IOption } from '../../ui/interfaces/selectors';
import { DocumentRejectionReasonEnum } from '../enums/document-rejection-reason.enum';

export const reasonsForRejectionOfDocument: IOption[] = [
  {
    label: 'Blurry image',
    value: DocumentRejectionReasonEnum.BLURRY,
  },
  {
    label: 'Incorrect Document',
    value: DocumentRejectionReasonEnum.INCORRECT_DOCUMENT,
  },
  {
    label: 'Expired',
    value: DocumentRejectionReasonEnum.EXPIRED,
  },
  {
    label: 'Other',
    value: DocumentRejectionReasonEnum.OTHER,
  },
];

export const reasonsForRejectionOfDocumentMap = {
  [DocumentRejectionReasonEnum.BLURRY]: 'Blurry image',
  [DocumentRejectionReasonEnum.INCORRECT_DOCUMENT]: 'Incorrect Document',
  [DocumentRejectionReasonEnum.EXPIRED]: 'Expired',
  [DocumentRejectionReasonEnum.OTHER]: '',
};
